import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

// maintenance
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// auth
const LoginPage = Loadable(lazy(() => import('pages/extra-pages/authentication/login/LoginPage')));
const LogoutPage = Loadable(lazy(() => import('pages/extra-pages/authentication/logout/LogoutPage')));

// home
const HomePage = Loadable(lazy(() => import('pages/extra-pages/HomePage')));

// data tables
const UsersListTable = Loadable(lazy(() => import('pages/extra-pages/tables/Users/UsersListTable')));
const UserDetail = Loadable(lazy(() => import('pages/extra-pages/tables/Users/user/UserDetail')));
const MessagesTable = Loadable(lazy(() => import('pages/extra-pages/tables/Messages/MessagesTable')));
const MessageDetail = Loadable(lazy(() => import('pages/extra-pages/tables/Messages/message/MessageDetail')));
const FlaggedMessagesTable = Loadable(lazy(() => import('pages/extra-pages/tables/Moderation/FlaggedMessagesTable')));
const PaymentsTable = Loadable(lazy(() => import('pages/extra-pages/tables/Payments/PaymentsTable')));
const FeedbackTable = Loadable(lazy(() => import('pages/extra-pages/tables/Feedback/FeedbackTable')));
const ErrorsTable = Loadable(lazy(() => import('pages/extra-pages/tables/Errors/ErrorsTable')));
const RevealsTable = Loadable(lazy(() => import('pages/extra-pages/tables/Reveals/RevealsTable')));
const HintsTable = Loadable(lazy(() => import('pages/extra-pages/tables/Hints/HintsTable')));

// analytics
const DailyStats = Loadable(lazy(() => import('pages/extra-pages/analytics/DailyStats')));
const RetentionStats = Loadable(lazy(() => import('pages/extra-pages/analytics/RetentionStats')));
const TopUsers = Loadable(lazy(() => import('pages/extra-pages/analytics/TopUsers')));
const PaymentRevenue = Loadable(lazy(() => import('pages/extra-pages/analytics/PaymentRevenue')));
const HintConversion = Loadable(lazy(() => import('pages/extra-pages/analytics/HintConversion')));
const BlockRate = Loadable(lazy(() => import('pages/extra-pages/analytics/BlockRate')));

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <Navigate to="/login" />
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/logout',
      element: <LogoutPage />
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        { index: true, element: <HomePage /> },
        { path: 'home', element: <HomePage /> },

        // users
        { path: 'users', element: <UsersListTable /> },
        { path: 'users/:user_id', element: <UserDetail /> },

        // messages
        { path: 'messages', element: <MessagesTable /> },
        { path: 'messages/flagged', element: <FlaggedMessagesTable /> },
        { path: 'messages/:message_id', element: <MessageDetail /> },

        // payments
        { path: 'payments', element: <PaymentsTable /> },

        // feedback / errors / reveals / hints
        { path: 'feedback', element: <FeedbackTable /> },
        { path: 'errors', element: <ErrorsTable /> },
        { path: 'reveals', element: <RevealsTable /> },
        { path: 'hints', element: <HintsTable /> },

        // analytics
        { path: 'analytics/daily', element: <DailyStats /> },
        { path: 'analytics/retention', element: <RetentionStats /> },
        { path: 'analytics/top-users', element: <TopUsers /> },
        { path: 'analytics/revenue', element: <PaymentRevenue /> },
        { path: 'analytics/hint-conversion', element: <HintConversion /> },
        { path: 'analytics/block-rate', element: <BlockRate /> }
      ]
    },
    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        { path: '404', element: <MaintenanceError /> },
        { path: '500', element: <MaintenanceError500 /> },
        { path: 'under-construction', element: <MaintenanceUnderConstruction /> },
        { path: 'coming-soon', element: <MaintenanceComingSoon /> }
      ]
    }
  ]
};

export default MainRoutes;
